import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {
    AgentCalendarManagementComponent
} from "../component/protected-components/agent-calendar-management/agent-calendar-management.component";
import {
    AgentPoolInfoDetailObjectComponent
} from "../component/protected-components/agent-pool-info-detail-object-component/agent-pool-info-detail-object.component";
import {
    AmAgentActiveObjectsComponent
} from "../component/protected-components/am-agent-active-objects/am-agent-active-objects.component";
import {
    AmAgentMainActiveObjectsComponent
} from "../component/protected-components/am-agent-main-active-objects/am-agent-main-active-objects.component";


const amModuleEntry: TestModuleDefinition = {
    key: 'am',
    label: 'Agent (am)',
    components: [
        {
            key: 'AgentCalendarManagementComponent',
            component: AgentCalendarManagementComponent,
            selector: 'am-agent-calendar-management',
            type: 'Component',
            label: 'Agent Calendar Management',
        },
        {
            key: 'AgentPoolInfoDetailObjectComponent',
            component: AgentPoolInfoDetailObjectComponent,
            selector: 'am-agent-pool-info-detail-object',
            type: 'Component',
            label: 'Agent Pool Info Detail'
        },
        {
            key: 'AmAgentActiveObjectsComponent',
            component: AmAgentActiveObjectsComponent,
            selector: 'am-agent-active-objects',
            type: 'Component',
            label: 'Agent Active Objects'
        },
        {
            key: 'AmAgentMainActiveObjectsComponent',
            component: AmAgentMainActiveObjectsComponent,
            selector: 'am-agent-main-active-objects',
            type: 'Component',
            label: 'Agent Main Active Objects'
        }
    ]
}

export const AM_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: amModuleEntry, multi: true }
];